/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/*global Slick */

expocadfx.boothList = function() {
	'use strict';
	var config = expocadfx.config;
	var data = expocadfx.fxData;
	var comparer = expocadfx.comparer;
    var boothDataView = new Slick.Data.DataView( {inlineFilters: false});
	var FxEvent = expocadfx.fxevent;
	var fxStyle = expocadfx.styles;
    var Grid = Slick.Grid;
	var elemById = expocadfx.element.elementById;
	var emailLink = expocadfx.emailLinkBuilder;
	var openEmail = expocadfx.openEmail;
    var txt = expocadfx.txt;
	var util = expocadfx.util;
	
    var doc = document;
	var gridAvailable = null;
    var divGrid = elemById( "boothGrid");
	var btnEmail = elemById( "btnBoothListEmail");
	
    var sortCol = "name";
	var sortAscending = true;
    var searchString = "";
	var locationColAscending = true;
	
    var columns;
    var options;
    
    
    function tagFormatter(row, cell, value, columnDef, dataContext) {
        var chkId = "chk" + row;
		var item;
		var inputClass = "exhChk ";
		var iconClass = "icon ";
		var icon = " icon-star-outline ";
		var elemTag = null;

		if( dataContext) {
			item = boothDataView.getItem(row);
			
			if( item.favorite) {
				icon = " icon-star-filled beat ";
			}
			
			elemTag = "<div id='" + chkId + "' class='" + inputClass + "' ><i class='" + 
				iconClass + icon + "'></i></div>"; 
		}
		return elemTag;
    }
    
    function availableFilter( item, args) {
        if( item.exhId === "" && data.booths[ item.boothIndex].status === "0") {
            if (args.searchString !== "" && 
                (item.name.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1 &&
                item.boothNumber.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1)) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }
	
    function taggedFilter( item, args) {
		if( item.favorite) {	
            if (args.searchString !== "" && 
                (item.name.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1 &&
                item.boothNumber.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1)) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }
	
    function viewOnlyFilter( item, args) {
        if( item.exhId === "" && item.bLocal && data.booths[ item.boothIndex].status === "0") {
            if (args.searchString !== "" && 
                (item.name.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1 &&
                item.boothNumber.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1)) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }
	
	function allFilter( item, args) {
		if (args.searchString !== "" && 
			(item.name.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1 &&
			item.boothNumber.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1)) {
			return false;
		}
		else {
			return true;
		}
	}
	
    function gridClickHandler( evt) {
		var obj = null;
        var cell = gridAvailable.getCellFromEvent( evt);
        var row = cell.row;
        var col = cell.cell;
        var targetRow = boothDataView.getItem(row);
		var boothIndex = targetRow.arBoothIndexes.join( ",");
		
        if( evt.target.tagName === "INPUT") {
            return;
        }
        
		if( col === 2) {      // location cell
			doc.dispatchEvent( new FxEvent( "Booth_Selected", { boothIndex:boothIndex}));
		}
		else if( col === 1) {
			obj = {
				exhibitorIndex : targetRow.id,
				boothIndex : boothIndex
			};

			doc.dispatchEvent( new FxEvent( "Exhibitor_Selected", obj));
		}
		else {
			obj = {
				boothNumber : targetRow.boothNumber,
				boothIndex : boothIndex,
				exhName : targetRow.name,
				exhId : targetRow.exhId,
				local : true,
				fav : !targetRow.favorite
			};

			targetRow.favorite = !targetRow.favorite;

			doc.dispatchEvent( new FxEvent( "Favorite_Change", obj));

			if( data.booths[ boothIndex].status !== "0") {
				doc.dispatchEvent( new FxEvent( "Exhibitor_Fav_Change", obj));
			}
				// force list update for filtered list
			boothDataView.sort( comparer( sortCol, sortAscending), sortAscending);
			gridAvailable.invalidate();
			
		}
    }
	
	function changeFav( boothNumber, exhibitorId, fav) {
		var obj = util.arrayFind( data.displayBooths, "boothNumber", boothNumber);
		
		if( obj) {
			obj.favorite = fav;
			
			boothDataView.refresh();
			
			boothDataView.sort( comparer( sortCol, sortAscending), sortAscending);
			gridAvailable.invalidate();
		}
	}
	
	function refreshBoothList() {
		boothDataView.sort( comparer( "location", locationColAscending), locationColAscending);
		boothDataView.sort( comparer( sortCol, sortAscending), sortAscending);
		gridAvailable.invalidate();
	}
	
	function exhibitorListHandler( evt) {
		var arr = String( evt.data.boothNumber).split( ",");
		var i = 0;
		for( i = 0; i < arr.length; i++) {
			changeFav( arr[i], evt.data.exhId, evt.data.fav);
		}
		doc.dispatchEvent( new FxEvent( "Favorite_Change", evt.data));
	}
	
	function exhibitorInfoHandler( evt) {
		changeFav( evt.data.boothNumber, evt.data.exhId, evt.data.fav);
		
		doc.dispatchEvent( new FxEvent( "Favorite_Change", evt.data));
	}
	
	function isTagged( obj) {
		return obj.favorite;
	}
	
	function emailTaggedHandler() {
		var boothNums = [];
		var link = "";
		var tagged = data.displayBooths.filter( isTagged);
		
		tagged.forEach( function( exhibitor) {
			boothNums = boothNums.concat( exhibitor.arBoothNumbers);
		});
		
		link = emailLink( boothNums.join( ","));
		openEmail( link);
	}
    
	function enableEmailTagged() {
		btnEmail.addEventListener( "click", emailTaggedHandler);
		util.removeClass( btnEmail, "disabled");
		btnEmail.style.color = elemById( "boothListHeader").style.color;
		btnEmail.style.cursor = "pointer";
	}
	
	function disableEmailTagged() {
		btnEmail.removeEventListener( "click", emailTaggedHandler);
		util.addClass( btnEmail, "disabled");
		btnEmail.style.color = config.DISABLED_GRAY;
		btnEmail.style.cursor = "auto";
	}
	
    function getListElements() {
		boothDataView.beginUpdate();
		boothDataView.setItems( data.displayBooths);
		boothDataView.setFilterArgs( { searchString: searchString});
		boothDataView.setFilter( availableFilter);
		
		boothDataView.endUpdate();
		//  get booth numbers in right order first
		boothDataView.sort( comparer( "location", true), true);
		boothDataView.sort( comparer( "name", true), true);
			
		gridAvailable = new Grid( divGrid, boothDataView, columns, options);
		gridAvailable.setSelectionModel(new Slick.RowSelectionModel());

			//  tell SlickGrid to mark exhibitor name field as sorted
		gridAvailable.setSortColumn( "boothSize", true);

		gridAvailable.onClick.subscribe( function( evt) {gridClickHandler( evt);});

		divGrid.getElementsByClassName("slick-header-columns")[0].style.backgroundColor =
				fxStyle.availableBooth.clrBg || fxStyle.mainHeader.clrBg;
		divGrid.getElementsByClassName("slick-header-columns")[0].style.color = 
			fxStyle.availableBooth.clrText || fxStyle.mainHeader.clrText;

		boothDataView.syncGridSelection( gridAvailable, false);

		gridAvailable.onSort.subscribe( function( e, args) {
			sortCol = args.sortCol.field;
			sortAscending = args.sortAsc;
			if( sortCol === "location") {
				locationColAscending = args.sortAsc;
			}
			
			boothDataView.sort( comparer( sortCol, args.sortAsc), args.sortAsc);
		});

		boothDataView.onRowsChanged.subscribe( function( evt, args) {
			gridAvailable.invalidateRows( args.rows);
			gridAvailable.render();
		});

		boothDataView.onRowCountChanged.subscribe( function() {
			gridAvailable.updateRowCount();
			gridAvailable.render();
		});
		
		doc.addEventListener( "Exhibitor_List_Fav_Change", exhibitorListHandler);
		doc.addEventListener( "Exhibitor_Info_Fav_Change", exhibitorInfoHandler);
		
		doc.addEventListener( "Display_Booth_Change", function() {
			boothDataView.sort( comparer( "location", locationColAscending), locationColAscending);
			boothDataView.sort( comparer( sortCol, sortAscending), sortAscending);
			gridAvailable.invalidate();
		});
		
		doc.addEventListener( "Booth_List_Change", refreshBoothList);
    }
	
    function updateFilter() {
        boothDataView.setFilterArgs( { searchString: searchString});
        boothDataView.refresh();
    }
	
    elemById( "boothSearch").addEventListener( "input", function () {
        searchString = this.value;
        updateFilter();
    });
	
	function returnToList() {
		elemById( "btnReturnList").removeEventListener( "click", returnToList);
		elemById( "boothList").style.display = "block";
		elemById( "boothTree").style.display = "none";
	}
	
	function showTree() {
		elemById( "boothList").style.display = "none";
		elemById( "boothTree").style.display = "block";
		elemById( "btnReturnList").addEventListener( "click", returnToList);
		
		elemById( "boothFilter").value = "available";
		boothDataView.setFilter( availableFilter);
		refreshBoothList();
	}
	
    if( elemById( "boothFilter")) {
        elemById( "boothFilter").addEventListener( "change", function( evt) {
            boothDataView.beginUpdate();
			
            if( evt.target.value === "all") {
                boothDataView.setFilter( allFilter);
				disableEmailTagged();
            }
            else if( evt.target.value === "hall") {
                boothDataView.setFilter( viewOnlyFilter);
				disableEmailTagged();
            }
            else if( evt.target.value === "tag") {
                boothDataView.setFilter( taggedFilter);
				enableEmailTagged();
            }
            else if( evt.target.value === "available") {
                boothDataView.setFilter( availableFilter);
				disableEmailTagged();
            }
            else if( evt.target.value === "bySize") {
                showTree();
            }
            
            boothDataView.endUpdate();
            boothDataView.syncGridSelection( gridAvailable, false);
        });
    }
	
    function refreshList() {
        gridAvailable.invalidate();
    }
	
	

    columns = [
        {id:"tagBooth", name: txt.MARK_ON_DRAWING, formatter: tagFormatter, minWidth: 44, maxWidth: 56, 
            resizable: false},
        {id: "boothSize", name: txt.EXHIBITOR, field: "name", sortable: true, cssClass: "cell-text", 
         minWidth: 150, maxWidth: 500},
        {id: "boothNo", name: txt.BOOTH, field: "location", sortable: true, 
         cssClass: "cell-text", minWidth: 80, maxWidth: 120}
        ];
	
    options = {
        enableCellNavigation: true,
        enableColumnReorder: false,
        forceFitColumns: true,
        rowHeight: 24
    };
    
    return {
        getListElements: getListElements,
        refreshList: refreshList,
		resize : function() {
			if( gridAvailable) {
				gridAvailable.resizeCanvas();
			}
		}
    };
};